import React, { useLayoutEffect, useState } from "react";
import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";
import {
  Badge,
  Layout,
  List,
  Card,
  Row,
  Col,
  Input,
  Button,
  Space,
} from "antd";
import {
  ALL_ROOMS,
  BOOKING_BY_ID,
  BOOKING_ROOMS_AVL,
  IMAGE_BASE_URL,
} from "../../constants/api";
import { displayMessage, getAPI, postAPI } from "../../utils/common";
import Meta from "antd/es/card/Meta";
import BookingDrawer from "../booking/BookingDrawer";
import { ERROR_MSG_TYPE } from "../../constants/messages";
import CheckoutModal from "../booking/CheckoutModal";
import { useNavigate } from "react-router-dom";
import { RollbackOutlined } from "@ant-design/icons";
import moment from "moment";

const BookingRequest = () => {
  const { Content } = Layout;
  let navigate = useNavigate();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  // Booking Checkout
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const today = moment();

  const checkRoomAvl = (room, date) => {
    const formattedCheckIn = moment(date).format("D MMM YY");
    const formattedCheckOut = moment(date).add(1, "day").format("D MMM YY");

    return new Promise((resolve) => {
      const successFn = function (data) {
        if (data.status === true) {
          resolve(true);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
          resolve(false);
        }
      };

      const errorFn = function () {
        displayMessage(ERROR_MSG_TYPE, "Failed to check room availability.");
        resolve(false);
      };

      const url =
        `${BOOKING_ROOMS_AVL}/${room.id}` +
        `/${encodeURIComponent(formattedCheckIn)}` +
        `/${encodeURIComponent(formattedCheckOut)}`;

      getAPI(url, successFn, errorFn);
    });
  };

  const openDrawer = async (room) => {
    const isAvailable = await checkRoomAvl(room, today);
    if (!isAvailable) return;

    setSelectedRoom(room);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedRoom(null);
    navigate(-1);
  };

  // Booking Checkout
  const openModel = (room) => {
    getBookingDetail(room.booking_id);
  };

  const getBookingDetail = (id) => {
    const successFn = function (data) {
      if (data.status === true) {
        setSelectedBooking(data.data);
        setIsModalVisible(true);
        setLoading(false);
      } else {
        setIsModalVisible(false);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setIsModalVisible(false);
      setLoading(false);
    };
    postAPI(BOOKING_BY_ID, { id: id }, successFn, errorFn);
  };

  const handleClose = () => {
    setIsModalVisible(false);
    setSelectedBooking(null);
    getData();
  };
  const [state, setState] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  useLayoutEffect(() => {
    getData();
  }, []);

  const getData = () => {
    setLoading(true);
    const successFn = function (data) {
      if (data.status === true) {
        const roomData = data["data"];
        setState(roomData);
        setFilteredData(roomData);
        setLoading(false);
      } else {
        setState([]);
        setFilteredData([]);
        setLoading(false);
      }
    };
    const errorFn = function () {
      setState([]);
      setFilteredData([]);
      setLoading(false);
    };
    getAPI(ALL_ROOMS, successFn, errorFn, {});
  };
  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = state.filter(
      (room) =>
        room.Name.toLowerCase().includes(value.toLowerCase()) ||
        room.RoomNo.toString().includes(value),
    );
    setFilteredData(filtered);
  };

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Row gutter={[16, 16]}>
          <Col md={24}>
            <Card
              loading={loading}
              style={{ textAlign: "right" }}
              extra={
                <Space>
                  <Input
                    placeholder="Search by Name or Room No"
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{ width: 300 }}
                  />
                  <Button
                    style={{
                      marginTop: "5px",
                      marginBottom: "5px",
                    }}
                    onClick={() => navigate(-1)}
                    type="primary"
                    ghost
                  >
                    <RollbackOutlined />
                  </Button>
                </Space>
              }
            >
              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 2,
                  md: 2,
                  lg: 3,
                  xl: 3,
                  xxl: 4,
                }}
                dataSource={filteredData}
                renderItem={(item) => (
                  <List.Item>
                    <Badge.Ribbon
                      text={
                        item.is_blocked
                          ? "Blocked"
                          : item.booking_enable
                            ? !item.is_booked
                              ? "Active"
                              : "Booked"
                            : "Disabled"
                      }
                      color={
                        item.is_blocked
                          ? "red"
                          : item.booking_enable
                            ? !item.is_booked
                              ? "green"
                              : "blue"
                            : "gray"
                      }
                    >
                      <Card
                        onClick={() =>
                          item.is_blocked
                            ? displayMessage(ERROR_MSG_TYPE, "Room is Blocked")
                            : item.booking_enable && !item.is_booked
                              ? openDrawer(item)
                              : item.is_booked
                                ? openModel(item)
                                : displayMessage(ERROR_MSG_TYPE, "Not Allowed")
                        }
                        style={{
                          padding: "10px",
                          textAlign: "center",
                          cursor: item.is_blocked ? "not-allowed" : "pointer",
                        }}
                        key={item.ID}
                        cover={
                          <img
                            alt="files"
                            src={
                              IMAGE_BASE_URL +
                              item?.room_images[0]?.image?.filePath
                            }
                            style={{
                              width: "100%",
                              filter: item.is_blocked
                                ? "grayscale(100%) opacity(0.5)"
                                : item.booking_enable && !item.is_booked
                                  ? "opacity(0.9)"
                                  : "opacity(0.5)",
                            }}
                          />
                        }
                      >
                        <Meta
                          title={`${item?.room_name?.toUpperCase()} (${
                            item.room_no
                          })`}
                        />
                      </Card>
                    </Badge.Ribbon>
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        </Row>

        {/* Pass selected room to the drawer */}
        <BookingDrawer
          open={isDrawerOpen}
          onClose={closeDrawer}
          room={selectedRoom}
          booking_type={"request"}
        />
        {/* Checkout Modal */}
        {isModalVisible && selectedBooking && (
          <CheckoutModal
            visible={isModalVisible}
            onClose={handleClose}
            booking={selectedBooking} // Pass the booking data here
          />
        )}
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default BookingRequest;
